module.exports = __webpack_public_path__ + "img/cover5.90f1a8a7.jpg";